import { Input, Directive, OnInit, ChangeDetectorRef, ElementRef } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { SurveyService } from '../../../core/services/survey/survey.service';
import { Question } from 'survey-core';
import { FormErrorsEnum } from '@tangilla/tg-ng-models';

@Directive()
export class TGFormControlQuestionDirective implements OnInit {
  @Input() label?: string;
  @Input() required = false;
  @Input() form!: FormGroup;
  @Input() defaultValue: any;
  @Input() disabled = false;
  @Input() customFormGroupClass = '';
  @Input() isLoading?: boolean;

  @Input() parentModel!: any;
  @Input() questionModel!: any;
  @Input() initializeFormQuestion = true;
  @Input() valueChangesPipe?: any;

  control?: UntypedFormControl | AbstractControl | null;

  constructor(protected surveyService: SurveyService,
              protected changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.control = this.form.get(this.questionModel.controlName);
    this.initializeQuestion();
    this.addQuestionToCurrentPage(this.control?.value);
  }

  initializeQuestion() {
    if (this.initializeFormQuestion) {
      this.form.get(this.questionModel.controlName)?.valueChanges
        .subscribe({
          next: (data: any) => {
            if (this.questionModel.valueChangesFunction) {
              this.questionModel.valueChangesFunction(data);
            }
            this.addControlQuestion(data);
          }
        });
    }
  }

  addControlQuestion(data: any) {
    const questionInSurvey = this.surveyService.surveyModel.getQuestionByName(this.questionModel!.name);
    if (questionInSurvey) {
      questionInSurvey.value = data;
    } else {
      this.addQuestionToCurrentPage(data);
    }
  }

  addQuestionToCurrentPage(data: any) {
    const questionInSurvey = this.surveyService.surveyModel.getQuestionByName(this.questionModel!.name);
    if (!questionInSurvey) {
      const questionToAdd = new Question(this.questionModel!.name);
      questionToAdd['type'] = this.questionModel['type'];
      questionToAdd.visible = false;
      questionToAdd.isRequired = !!this.questionModel.isRequired;

      const currentPage = this.surveyService.surveyModel
        .getPageByQuestion(this.parentModel!);

      currentPage.addQuestion(questionToAdd);

      const questionAdded = this.surveyService.surveyModel.getQuestionByName(this.questionModel!.name);
      questionAdded['identifyingQuestion'] = !!this.questionModel.identifyingQuestion;
      questionAdded['includeInOutput'] = this.questionModel.includeInOutput !== false;
      questionAdded.value = data;
    }
  }

  hasErrors() {
    const question = this.surveyService.surveyModel.getQuestionByName(this.questionModel.name);

    return question.errors.length > 0 || this.controlHasError();
  }

  getErrorMessage() {
    const question = this.surveyService.surveyModel.getQuestionByName(this.questionModel.name);
    return question.errors && question.errors.length > 0 ? question.errors[0].text :
      this.getFormControlErrorMessage() ? this.getFormControlErrorMessage() : '';
  }

  controlHasError(): boolean | null | undefined {
    return this.control && this.control.errors && this.formControlHasErrors(this.control);
  }

  formControlHasErrors(control: FormControl | AbstractControl): boolean {
    return control && !control.valid && control.touched;
  }

  getFormControlErrorMessage() {
    if (this.control?.errors && this.control?.errors['invalidWithMessage'] && this.control.errors['errorMessage']) {
      return this.control.errors['errorMessage'];
    }
    const keys = Object.keys(this.control ? this.control.errors ? this.control.errors : [] : []);
    let key;
    if (keys.includes('pattern')) {
      // @ts-ignore
      key = this.control?.errors?.pattern?.requiredPattern;
    } else if (keys.includes('required')) {
      return 'Required Response';
    } else if (keys.includes('expDate')) {
      return 'Invalid Expiration Date';
    } else if (keys.includes('ccNumber')) {
      return 'Invalid Credit Card Number';
    } else if (keys.includes('mask')) {
      // @ts-ignore
      key = this.control?.errors?.mask?.requiredMask;
    } else {
      key = keys[0];
    }
    const index = Object.keys(FormErrorsEnum).indexOf(key);
    return Object.values(FormErrorsEnum)[index];
  }
}
